import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
	Box,
	Tooltip,
	OutlinedInput,
	InputLabel,
	MenuItem,
	FormControl,
	ListItemText,
	Select,
	Checkbox,
	makeStyles,
	TextField,
	useTheme,
} from "@material-ui/core"
import Skeleton from "@material-ui/lab/Skeleton"
import { useSelector } from "react-redux"
import { KeyboardArrowDown } from "@material-ui/icons"

const useStyles = makeStyles((theme) => ({
	boxWrapper: {
		maxWidth: 170,
		minWidth: 170,
		minHeight: 48,
		maxHeight: 48,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "transparent",
		},
		"& .MuiSelect-icon.Mui-disabled": {
			opacity: "0.5",
		},
		"& .MuiFormLabel-root.Mui-disabled": {
			color: "#9E9E9E!important",
		},
	},
}))

//basic settings
const MenuProps = {
	PaperProps: {
		style: {
			width: 170,
			maxHeight: 287,
			textTransform: "capitalize",
		},
	},
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	variant: "menu",
	getContentAnchorEl: null,
}

const CommentsBy = ({ handleCommentByChange, selected = [], setSelected = () => {}, disableFilters }) => {
	const classes = useStyles()
	const theme = useTheme()
	const [t] = useTranslation("global")

	const users = useSelector((state) => state.info?.usersList || [])
	const isLoading = useSelector((state) => state.info?.isLoading)

	const isAllSelected = users.length > 0 && selected.length === users.length

	const handleChange = (event) => {
		const value = event.target.value
		if (value[value.length - 1] === "all") {
			setSelected(selected.length === users.length ? [] : users.map((user) => user?.username))
			const ids = selected.length === users.length ? [] : users.map((user) => user?.user_id)
			handleCommentByChange(ids)
			return
		}
		setSelected(value)
		const ids = users.filter((user) => value.includes(user?.username)).map((user) => user?.user_id)
		handleCommentByChange(ids)
	}

	return (
		<Box className={classes.boxWrapper} m={1}>
			<FormControl fullWidth size="small">
				{/* <InputLabel style={{ fontWeight: 400 }} id="user-select-label">
					Comments By
				</InputLabel> */}
				<Tooltip placement="top" arrow title={selected.join(", ")}>
					{/* <Select
						labelId="user-multiple-checkbox-label"
						id="user-multiple-checkbox"
						multiple
						value={selected}
						onChange={handleChange}
						input={<OutlinedInput label="Comments By" />}
						renderValue={(selected) => selected.join(", ")}
						MenuProps={MenuProps}
						IconComponent={KeyboardArrowDown}
					> */}
					<TextField
						//style={{ width: "100%" }}
						//style={{ color: "#2C3533", fontWeight: "700" }}
						variant="outlined"
						value={selected}
						onChange={handleChange}
						select
						label={t("filters.comments_by")}
						id="user-multiple-checkbox-label"
						SelectProps={{
							labelId: "user-multiple-checkbox-label",
							MenuProps: MenuProps,
							IconComponent: KeyboardArrowDown,
							renderValue: (selected) => selected.join(", "),
							multiple: true,
							//classes: { icon: { color: "#2C3533" } },
							// value: selected,
							// onChange: handleChange,
							onOpen: () => {
								setTimeout(() => {
									selected?.length > 0 &&
										!isAllSelected &&
										document.querySelector(`[data-name=${selected?.[0]}]`)?.scrollIntoView()
								}, 1)
							},
						}}
						InputLabelProps={{
							style: { ...theme.typography.body1, top: "-4px" },
							// classes: {
							// 	icon: {
							// 		color: "#2C3533",
							// 	},
							// },
						}}
						disabled={disableFilters}
						// inputProps={{
						// 	classes: {
						// 		icon: { co },
						// 	},
						// }}
						size="small"
						className={classes.select}
					>
						{isLoading &&
							Array(5)
								.fill()
								.map((data, i) => (
									<MenuItem key={i} value={""}>
										<Skeleton variant="text" width={130} height={40} animation="wave" />
									</MenuItem>
								))}
						{users.length > 0 && (
							<MenuItem style={{ maxWidth: 170, paddingLeft: 1 }} key={"all"} value={"all"}>
								<Checkbox size="small" checked={isAllSelected} />
								<ListItemText primary={t("filters.all")} primaryTypographyProps={{ variant: "body2" }} />
							</MenuItem>
						)}
						{users.map((user) => (
							<MenuItem
								style={{ maxWidth: 170, paddingLeft: 1 }}
								key={user?.user_id}
								value={user?.username}
								data-name={user?.username}
							>
								<Checkbox size="small" checked={selected.indexOf(user?.username) > -1} />
								<Tooltip placement="top" arrow title={user?.username}>
									<ListItemText primary={user?.username} primaryTypographyProps={{ style: { variant: "body2" } }} />
								</Tooltip>
							</MenuItem>
						))}
					</TextField>
				</Tooltip>
			</FormControl>
		</Box>
	)
}

export default CommentsBy
